export enum ProjectTypeEnum {
  RSEE = "RSEE",
  BIM = "BIM",
  BIM_ORGANIZATION = "BIM_ORGANIZATION",
  RSEE_ORGANIZATION = "RSEE_ORGANIZATION",
}
